// extracted by mini-css-extract-plugin
export default {"cta":"tG-z","disabled":"uG-z"};